/* corex-textil-editor-draw.js · Dibujo de guías del personalizador de camisetas sobre la prenda proyectada:
   contorno y etiqueta de cada impresión, cota al cuello, eje central y selección de capas.
   Todas las funciones reciben el contexto en px de imagen y `px` = px de imagen por px CSS. */
(function () {
  'use strict';

  var G = window.CorexTextilGeo;
  var RED = '#E2211C';
  var MUTED = '#8C867E';
  var SEL = '#1D6FE0';
  var HANDLE_PX = 9;
  var ROT_PX = 26;

  function fmt(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function signed(v) { return (v > 0 ? '+' : v < 0 ? '−' : '') + fmt(Math.abs(v)); }

  function drawPill(c, text, x, y, px, bg, fg, align) {
    var w = c.measureText(text).width + 12 * px, h = 18 * px;
    var x0 = align === 'left' ? x : x - w / 2;
    c.fillStyle = bg;
    if (c.roundRect) { c.beginPath(); c.roundRect(x0, y, w, h, 4 * px); c.fill(); } else c.fillRect(x0, y, w, h);
    c.fillStyle = fg;
    c.textAlign = 'left';
    c.textBaseline = 'top';
    c.fillText(text, x0 + 6 * px, y + 3.5 * px);
    return { x: x0, y: y, w: w, h: h };
  }
  function cornersUV(area) {
    var x0 = area.cu - area.w / 2, x1 = area.cu + area.w / 2;
    return [{ u: x0, v: area.top }, { u: x1, v: area.top }, { u: x1, v: area.top + area.h }, { u: x0, v: area.top + area.h }];
  }

  /* Área libre de la impresión activa (hasta dónde se pueden colocar capas): contorno tenue de puntos. */
  function freeArea(c, frame, area, px) {
    c.save();
    c.strokeStyle = 'rgba(140,134,126,0.45)';
    c.lineWidth = 1 * px;
    c.setLineDash([2 * px, 4 * px]);
    G.tracePath(c, G.projectedQuad(frame, cornersUV(area), 24));
    c.stroke();
    c.restore();
  }
  /* Contorno de una impresión (caja real del diseño o, sin capas, la caja por defecto) y su etiqueta (asa para
     arrastrarla). Devuelve el rectángulo de la etiqueta en px de imagen. */
  function printOutline(c, frame, area, px, opts) {
    c.save();
    c.strokeStyle = opts.warn ? RED : opts.active ? RED : MUTED;
    c.globalAlpha = opts.empty && !opts.active ? 0.7 : 1;
    c.lineWidth = (opts.active ? 2 : 1.5) * px;
    c.setLineDash([7 * px, 5 * px]);
    G.tracePath(c, G.projectedQuad(frame, cornersUV(area), 24));
    c.stroke();
    if (opts.warn) {
      c.setLineDash([]);
      c.globalAlpha = 0.12;
      c.fillStyle = RED;
      c.fill();
      c.globalAlpha = 1;
    }
    c.setLineDash([]);
    if (opts.noLabel) { c.restore(); return null; }
    c.font = '700 ' + 11.5 * px + 'px ' + opts.font;
    var tl = frame.fwd(area.cu - area.w / 2, area.top);
    var rect = drawPill(c, opts.label, tl.x, tl.y - 22 * px, px, opts.active ? RED : 'rgba(255,255,255,0.92)', opts.active ? '#FFFFFF' : '#141414', 'left');
    c.restore();
    return rect;
  }

  /* Cota roja: del cuello al borde superior de la impresión, a su izquierda. noPill: sin etiqueta (la pone el
     editor en HTML para poder editarla); devuelve el punto donde acaba la cota (borde derecho de la etiqueta). */
  function neckCota(c, frame, area, px, font, noPill) {
    return vCota(c, frame, area, px, font, 0, area.top, fmt(area.top) + ' cm', noPill);
  }
  /* Cota roja de manga: del bajo de la manga (v = largo) al borde inferior de la impresión. dist null = sin rellenar. */
  function hemCota(c, frame, area, px, font, dist, noPill) {
    return vCota(c, frame, area, px, font, frame.hemV, area.top + area.h, dist == null ? '? cm' : fmt(dist) + ' cm', noPill);
  }
  /* Cota vertical a la izquierda de la impresión: referencia en vRef (con línea hasta el eje) y extremo en vEnd. */
  function vCota(c, frame, area, px, font, vRef, vEnd, t, noPill) {
    var x = frame.fwd(area.cu - area.w / 2 - 1.4, 0).x - 6 * px;
    var y0 = frame.fwd(0, vRef).y, y1 = frame.fwd(0, vEnd).y;
    c.save();
    c.strokeStyle = RED;
    c.lineWidth = 2 * px;
    c.setLineDash([3 * px, 3 * px]);
    c.beginPath();
    c.moveTo(Math.min(x, frame.cx), y0);
    c.lineTo(Math.max(x, frame.cx), y0);
    c.stroke();
    c.setLineDash([]);
    c.beginPath();
    c.moveTo(x, y0); c.lineTo(x, y1);
    c.moveTo(x - 6 * px, y0); c.lineTo(x + 6 * px, y0);
    c.moveTo(x - 6 * px, y1); c.lineTo(x + 6 * px, y1);
    c.stroke();
    var anchor = { x: x - 8 * px, y: (y0 + y1) / 2 };
    if (!noPill) {
      c.font = '700 ' + 12 * px + 'px ' + font;
      var w = c.measureText(t).width + 12 * px;
      drawPill(c, t, x - w / 2 - 8 * px, (y0 + y1) / 2 - 9 * px, px, RED, '#FFFFFF');
    }
    c.restore();
    return anchor;
  }

  /* Eje central de la prenda. (La cota horizontal eje → centro se quitó: bajo el diseño se confundía con la de
     ancho, que ahora es una línea HTML de borde a borde de la selección; el desplazamiento está en «Más opciones».) */
  function centerAxis(c, frame, px) {
    var axisTop = frame.fwd(0, 0), axisBottom = frame.fwd(0, frame.hemV);
    c.save();
    c.strokeStyle = 'rgba(140,134,126,0.55)';
    c.lineWidth = 1 * px;
    c.setLineDash([2 * px, 4 * px]);
    c.beginPath(); c.moveTo(axisTop.x, axisTop.y); c.lineTo(axisBottom.x, axisBottom.y); c.stroke();
    c.restore();
  }

  /* Asa de giro de una capa, en cm de la impresión. cmPerPx = cm por px CSS en el centro. */
  function rotHandle(l, cmPerPx) {
    var s = G.layerSize(l);
    return G.fromLocal(l, { x: 0, y: -s.h / 2 - ROT_PX * cmPerPx });
  }
  /* Selección de una capa. m: { cu, cv, cmPerPx } de su impresión. */
  function selection(c, frame, l, px, m) {
    var hs = HANDLE_PX * px;
    var toUV = function (p) { return { u: p.x + m.cu, v: p.y + m.cv }; };
    var corners = G.layerCorners(l).map(toUV);
    c.save();
    c.strokeStyle = SEL;
    c.lineWidth = 1.5 * px;
    c.setLineDash([]);
    G.tracePath(c, G.projectedQuad(frame, corners, 16));
    c.stroke();
    var topMid = toUV(G.fromLocal(l, { x: 0, y: -G.layerSize(l).h / 2 })), rh = toUV(rotHandle(l, m.cmPerPx));
    var a = frame.fwd(topMid.u, topMid.v), b = frame.fwd(rh.u, rh.v);
    c.beginPath(); c.moveTo(a.x, a.y); c.lineTo(b.x, b.y); c.stroke();
    c.fillStyle = '#FFFFFF';
    corners.forEach(function (uv) {
      var p = frame.fwd(uv.u, uv.v);
      c.fillRect(p.x - hs / 2, p.y - hs / 2, hs, hs);
      c.strokeRect(p.x - hs / 2, p.y - hs / 2, hs, hs);
    });
    c.beginPath(); c.arc(b.x, b.y, hs * 0.65, 0, Math.PI * 2); c.fill(); c.stroke();
    c.restore();
  }

  /* Contorno fino de una capa seleccionada que no es la principal (selección múltiple). */
  function layerOutline(c, frame, l, px, m) {
    var corners = G.layerCorners(l).map(function (p) { return { u: p.x + m.cu, v: p.y + m.cv }; });
    c.save();
    c.strokeStyle = SEL;
    c.lineWidth = 1.2 * px;
    c.setLineDash([4 * px, 3 * px]);
    G.tracePath(c, G.projectedQuad(frame, corners, 16));
    c.stroke();
    c.restore();
  }

  window.CorexTextilDraw = {
    HANDLE_PX: HANDLE_PX, drawPill: drawPill, printOutline: printOutline, freeArea: freeArea, neckCota: neckCota, hemCota: hemCota, centerAxis: centerAxis,
    rotHandle: rotHandle, selection: selection, layerOutline: layerOutline, signed: signed
  };
})();
